export default __webpack_public_path__ + "171ec6232b9cb7eb1ea667e709f9c0ec.png";